import { render, staticRenderFns } from "./ThePartnerSettingList.vue?vue&type=template&id=2063f081&scoped=true"
import script from "./ThePartnerSettingList.vue?vue&type=script&lang=ts"
export * from "./ThePartnerSettingList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2063f081",
  null
  
)

export default component.exports